namespace RioERP.Shipping {
    export interface ShippingTrackingNumbersExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ShippingTrackingNumbersExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'RioERP.ShippingTrackingNumbersExcelImportForm';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ShippingTrackingNumbersExcelImportForm.init)  {
                ShippingTrackingNumbersExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ShippingTrackingNumbersExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
